export const SalesTransactionsPermissions = {

  ViewAndSearchInMainAccountsSalesTransactionsPage: {
    permissionsId: '3c166ff7-5ca8-46d5-c9d5-08d94f66fc61',
    permissionsName: 'View and Search in main Accounts Sales Transactions page',
    componentsId: null,
    components: null
  },
  ViewAccountsSaleTransactionPage:
  {
    permissionsId: 'ebcf8c60-a40b-4614-1485-08d9686a2a06',
    permissionsName: 'View Accounts sale transaction page',
    componentsId: null,
    components: null
  },
  ViewTransactionsDetails:
  {
    permissionsId: '9803cb5a-c7ff-493c-1486-08d9686a2a06',
    permissionsName: 'View Transactions Details',
    componentsId: null,
    components: null
  },
  ViewContactDetails:
  {
    permissionsId: 'efca7c1a-d549-44c6-1487-08d9686a2a06',
    permissionsName: 'View Contact Details',
    componentsId: null,
    components: null
  },
  ViewReferenceDetails:
  {
    permissionsId: '9bdd1bb2-ea1b-47f0-1488-08d9686a2a06',
    permissionsName: 'View Reference Details',
    componentsId: null,
    components: null
  },
  UpdateReferenceDetailsInSalesTransactions:
  {
    permissionsId: '0ddeaa0e-015f-44ca-1489-08d9686a2a06',
    permissionsName: 'Update Reference Details In Sales Transactions (Account)',
    componentsId: null,
    components: null
  },
  ViewEarning:
  {
    permissionsId: '92143971-61bc-40c2-148a-08d9686a2a06',
    permissionsName: 'View Earning',
    componentsId: null,
    components: null
  },
  ViewInvoicesInSalesTransactions:
  {
    permissionsId: '3d1d6928-c0a3-4a12-148b-08d9686a2a06',
    permissionsName: 'View Invoices In Sales Transactions (Account)',
    componentsId: null,
    components: null
  },
  ViewChequeRequestDetails:
  {
    permissionsId: '1d25e8c5-9283-40d4-148c-08d9686a2a06',
    permissionsName: 'View Cheque Request Details',
    componentsId: null,
    components: null
  },
  ViewAllChequeRequest:
  {
    permissionsId: '996e1010-9765-4fef-148d-08d9686a2a06',
    permissionsName: 'View All Cheque Request',
    componentsId: null,
    components: null
  },
  AddChequeRequestForm:
  {
    permissionsId: '601ce67a-eed8-4dc8-148e-08d9686a2a06',
    permissionsName: 'Add Cheque Request Form',
    componentsId: null,
    components: null
  },
  ViewDecumentInSalesTransactions:
  {
    permissionsId: '489934eb-ee17-431e-148f-08d9686a2a06',
    permissionsName: 'View Decument In Sales Transactions (Account)',
    componentsId: null,
    components: null
  },
  AddNewDocument:
  {
    permissionsId: '39198685-5200-486a-1490-08d9686a2a06',
    permissionsName: 'Add New Document',
    componentsId: null,
    components: null
  }

};
